import React, { useEffect, useState } from "react";

import { useField } from "formik";
import { useSelector } from "react-redux";
import { Dropdown, Modal, Segment } from "semantic-ui-react";
import AddProduct from "../../AddProduct";

function ProductInput() {
	const { allProducts: products } = useSelector((state) => state.products);

	const [
		,
		{ error: productValidationError, touched },
		{ setValue },
	] = useField("productId");
	const [{ value: categoryValue }] = useField("category");

	const [categoryFilteredProducts, setCategoryFilteredProducts] = useState(
		products
	);

	const [newProductName, setNewProductName] = useState("");
	const [openAddModal, setOpenAddModal] = useState(false);

	useEffect(() => {
		if (categoryValue)
			setCategoryFilteredProducts(
				products.filter(
					(item) =>
						item.category?._id === categoryValue ||
						item.category === categoryValue
				)
			);
		else setCategoryFilteredProducts(products);
	}, [categoryValue, products]);

	return (
		<>
			<label
				style={{
					fontSize: ".92857143em",
					display: "block",
					margin: "0 0 .28571429rem 0",
					fontWeight: "700",
				}}
			>
				Product
			</label>
			<Dropdown
				fluid
				search
				selection
				clearable
				allowAdditions
				onAddItem={(e, b) => {
					console.log({ tg: e.target });
					setNewProductName(e.target.innerText.substr(4));
					setOpenAddModal(true);
				}}
				selectOnBlur={false}
				style={{ textTransform: "capitalize", position: "relative" }}
				onChange={(e, b) => {
					if (b.value === "add") setOpenAddModal(true);
					else setValue(b.value);
				}}
				placeholder="Choose Product"
				options={categoryFilteredProducts.map((item) => ({
					key: item._id,
					value: item._id,
					text: item.name,
				}))}
			/>
			<p style={{ color: "red" }}>
				{productValidationError && touched && productValidationError}
			</p>

			<Modal
				open={openAddModal}
				onClose={() => setOpenAddModal(false)}
				closeOnEscape
			>
				<Segment basic>
					<AddProduct name={newProductName} />
				</Segment>
			</Modal>
		</>
	);
}

export default ProductInput;
